// removed by extract-text-webpack-plugin
module.exports = {"comparison-feature-container":"ComparisonFeature__comparison-feature-container","comparisonFeatureContainer":"ComparisonFeature__comparison-feature-container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonFeature/ComparisonFeature.desktop.css
// module id = 1319
// module chunks = 8